import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const HAIR = [
  { id: "short-curly-brown", label: "short curly brown" },
  { id: "long-straight-black", label: "long straight black" },
  { id: "blonde-wavy", label: "blonde wavy" },
  { id: "red-curly", label: "red curly" },
  { id: "dark-braids", label: "dark braids" },
  { id: "short-straight-brown", label: "short straight brown" },
];
const SKIN = ["fair", "light", "medium", "olive", "brown", "deep"];
const GENDERS = ["Girl", "Boy", "Kid"];

function ChipRow({ items, value, onChange, activeClass, testidPrefix, getKey = (v) => v, getLabel = (v) => v }) {
  return (
    <div className="flex flex-wrap gap-2 mt-1">
      {items.map((v) => {
        const k = getKey(v);
        const l = getLabel(v);
        const isActive = value === l;
        return (
          <button key={k} data-testid={`${testidPrefix}-${k}`} type="button"
            onClick={() => onChange(l)}
            className={`pill-tag border ${isActive ? activeClass : "bg-white text-[#2B2D42] border-[#e8dfd1]"}`}>
            {l}
          </button>
        );
      })}
    </div>
  );
}

export default function StepChild({ child, setChild }) {
  return (
    <div className="space-y-5" data-testid="step-1">
      <h1 className="font-display text-3xl font-bold text-[#2B2D42]">Tell us about your little star.</h1>
      <p className="text-[#4A4E69]">These details make the book feel truly theirs.</p>
      <div>
        <Label>Child's first name</Label>
        <Input data-testid="child-name-input" value={child.name}
          onChange={(e) => setChild({ ...child, name: e.target.value })}
          placeholder="e.g. Milo" className="text-lg" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label>Age</Label>
          <Input data-testid="child-age-input" type="number" min={2} max={12}
            value={child.age} onChange={(e) => setChild({ ...child, age: parseInt(e.target.value || "5") })} />
        </div>
        <div>
          <Label>They are a…</Label>
          <ChipRow items={GENDERS} value={child.gender}
            onChange={(v) => setChild({ ...child, gender: v })}
            activeClass="bg-[#2B2D42] text-white border-[#2B2D42]"
            testidPrefix="gender" />
        </div>
      </div>
      <div>
        <Label>Skin tone</Label>
        <ChipRow items={SKIN} value={child.skin_tone}
          onChange={(v) => setChild({ ...child, skin_tone: v })}
          activeClass="bg-[#E07A5F] text-white border-[#E07A5F]"
          testidPrefix="skin" />
      </div>
      <div>
        <Label>Hair</Label>
        <ChipRow items={HAIR} value={child.hair}
          onChange={(v) => setChild({ ...child, hair: v })}
          activeClass="bg-[#81B29A] text-white border-[#81B29A]"
          testidPrefix="hair"
          getKey={(v) => v.id} getLabel={(v) => v.label} />
      </div>
      <div>
        <Label>Favorite thing / toy (optional)</Label>
        <Input data-testid="favorite-input" value={child.favorite_thing}
          onChange={(e) => setChild({ ...child, favorite_thing: e.target.value })}
          placeholder="e.g. a stuffed bunny called Biscuit" />
      </div>
    </div>
  );
}
